export function countryName(code) {
  if (!code) return 'Location unavailable';
  try { return new Intl.DisplayNames(['en'], { type: 'region' }).of(code); } catch { return code; }
}
export function visitorContextLabel(raw) {
  let context;
  try { context = typeof raw === 'string' ? JSON.parse(raw) : raw; } catch { return 'Visitor details unavailable'; }
  if (!context) return 'Recorded before visitor details were added';
  return [countryName(context.country), context.region, context.device, context.referrer || 'No referring site supplied', context.visitor_id ? `Visitor ${context.visitor_id.slice(0, 8)}` : '', context.environment === 'test' ? 'Test visit' : ''].filter(Boolean).join(' · ');
}
